/**
 * Function that calculates the integral of the line between two
 * x-coordinates, given the slope and intercept of the line.
 * @param x0
 * @param x1
 * @param slope
 * @param intercept
 * @return integral value.
 */
export default function integral(
/** first coordinate of point */
x0, 
/** second coordinate of point */
x1, 
/** slope of the line */
slope, 
/** intercept of the line on the y axis */
intercept) {
    return (0.5 * slope * x1 * x1 +
        intercept * x1 -
        (0.5 * slope * x0 * x0 + intercept * x0));
}
//# sourceMappingURL=integral.js.map